/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import cx from 'classnames';

const PREFIX = 'is-';

function prefix(cls) {
	if (cls.length === 0 || cls.indexOf('-') >= 0 || cls.substr(0, 3) === 'is-') {
		return cls;
	}

	return `${PREFIX}${cls}`;
}

/**
 * Follows the same behavior as the normal 'classnames' library. If a classname has no hyphens then it is considered
 * a modifier and thereby prefixed with 'is-'.
 */
export default (...args) => {
	for (let i = 0; i < args.length; i++) {
		const arg = args[i];
		if (typeof arg === 'string') {
			args[i] = prefix(arg);
		} else if (arg && typeof arg === 'object') {
			args[i] = {};
			Object.keys(arg).forEach(key => (args[i][prefix(key)] = arg[key]));
		}
	}

	return cx(...args);
};
